function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import Form from "semantic-ui-react/dist/es/collections/Form/Form.js";
import Message from "semantic-ui-react/dist/es/collections/Message/Message.js";
import { size } from "../../../utils/size";
import { forEach } from "../../../utils/for-each";
import { Button } from "../../elements/Button";
import { Heading } from "../../typography/Heading";
import { Link } from "../../elements/Link";
import { SEND } from "../../../utils/default-strings";
import { getEmptyState } from "./utils/getEmptyState";
import { setInputState } from "./utils/setInputState";
import { getValidationWithDefaults } from "./utils/getValidationWithDefaults";
import { getEmptyRequiredInputs } from "./utils/getEmptyRequiredInputs";
import { getFormChild } from "./utils/getFormChild";
import { getFormInputsState } from "./utils/getFormInputsState";
import { getIsSubmitButtonDisabled } from "./utils/getIsSubmitButtonDisabled";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      if (!previousProps.successMessage && !!_this.props.successMessage) {
        var emptyState = getEmptyState(_this.state);

        _this.setState(emptyState);
      }

      Object.entries(_this.state).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            inputName = _ref2[0],
            inputState = _ref2[1];

        var previousInputState = previousState[inputName];
        getFormInputsState(_assertThisInitialized(_this), inputName, inputState, previousInputState);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputBlur", function (name) {
      return setInputState(_assertThisInitialized(_this), name, {
        isBlurred: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (name, value) {
      return setInputState(_assertThisInitialized(_this), name, {
        isBlurred: false,
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var emptyRequiredInputs = getEmptyRequiredInputs(_this.props.validation, _this.state);
      size(emptyRequiredInputs) ? forEach(emptyRequiredInputs, function (validation, name) {
        var _getValidationWithDef = getValidationWithDefaults(validation),
            isRequiredMessage = _getValidationWithDef.isRequiredMessage;

        _this.setState(_defineProperty({}, name, {
          error: isRequiredMessage
        }));
      }) : _this.props.onSubmit(_this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          actionLink = _this$props.actionLink,
          autoComplete = _this$props.autoComplete,
          children = _this$props.children,
          errorMessage = _this$props.errorMessage,
          headingText = _this$props.headingText,
          submitButtonText = _this$props.submitButtonText,
          successMessage = _this$props.successMessage;
      return React.createElement(Card, {
        className: "has-form",
        fluid: true
      }, headingText && React.createElement(Card.Content, null, React.createElement(Heading, null, headingText)), React.createElement(Card.Content, null, React.createElement(Form, {
        autoComplete: autoComplete,
        error: !!errorMessage,
        onSubmit: _this.handleSubmit,
        success: !!successMessage
      }, Children.map(children, function (child) {
        return getFormChild(child, _assertThisInitialized(_this));
      }), !!successMessage && React.createElement(Message, {
        content: successMessage,
        success: true
      }), !!errorMessage && React.createElement(Message, {
        content: errorMessage,
        error: true
      }), actionLink && React.createElement(Link, {
        onClick: actionLink.onClick
      }, actionLink.text), React.createElement(Button, {
        isDisabled: getIsSubmitButtonDisabled(_this.state),
        isFormSubmit: true,
        isPositionedRight: true,
        isRounded: true
      }, submitButtonText || SEND))));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'Form';
Component.defaultProps = {
  autoComplete: null,
  errorMessage: '',
  headingText: null,
  onSubmit: Function.prototype,
  actionLink: null,
  submitButtonText: SEND,
  successMessage: '',
  validation: {}
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  actionLink: PropTypes.shape({
    onClick: PropTypes.func,
    text: PropTypes.node.isRequired
  }),
  autoComplete: PropTypes.oneOf(['on', 'off']),
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string,
  headingText: PropTypes.string,
  onSubmit: PropTypes.func,
  submitButtonText: PropTypes.string,
  successMessage: PropTypes.string,
  validation: PropTypes.objectOf(PropTypes.shape({
    getIsEmpty: PropTypes.func,
    getIsValid: PropTypes.func,
    invalidMessage: PropTypes.string,
    isRequired: PropTypes.bool,
    isRequiredMessage: PropTypes.string
  }))
} : {};